import { Link, usePage } from '@inertiajs/react';
import classNames from 'classnames';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { useRouter } from '../router';
import { PageProps } from '../types';
import Container from '../UI/Container';

export function DashboardLayout({
  children,
}: {
  children: ReactNode;
}) {
  const { component } = usePage<PageProps>();

  return (
    <>
      <DashboardHeader component={component} />
      {children}
    </>
  );
}

export function DashboardHeader({
  component,
}: {
  component: string;
}) {
  const { t } = useTranslation();
  const { routes } = useRouter();

  return (
    <div className="bg-white border-b">
      <Container className="!py-3 text-center">
        <div className="space-x-2">
          <Link
            href={routes.dashboard_page()}
            className={tabClasses({ active: component === 'Backend/Dashboard/DashboardPage' })}
          >
            {t('backend:revenue')}
          </Link>
          <Link
            href={routes.mail_dashboard_page()}
            className={tabClasses({ active: component === 'Backend/Dashboard/MailDashboardPage' })}
          >
            {t('backend:mails')}
          </Link>
        </div>
      </Container>
    </div>
  );
}

function tabClasses({
  active,
}: {
  active?: boolean;
}) {
  return classNames(
    'font-medium py-1 px-2 inline-block rounded',
    active
      ? 'bg-blue-200 text-blue-900 hover:text-blue-900'
      : 'text-blue-700 hover:bg-blue-100 hover:text-blue-900'
  );
}
